@if (workspace() === Workspace.Internal || sessionState() === SessionState.Ready) {
    <div class="flex h-dvh w-dvw flex-col overflow-hidden">
        <div class="flex min-h-0 flex-1">
            <adv-sidebar
                class="shrink-0"
                [(expanded)]="expanded"
                [(mobileOpen)]="mobileOpen"
                [mobileTitle]="sidebarTitleText"
                [attr.aria-expanded]="sidebarOpen()">
                <adv-sidebar-header>
                    <ng-template advSidebarExpanded>
                        @if (workspace() === Workspace.Customer) {
                            <button
                                pButton
                                variant="text"
                                severity="secondary"
                                (click)="cs.toggle($event)"
                                class="!w-full !p-0.5"
                                [attr.aria-label]="customerSelectorText()">
                                <div class="flex w-full items-center justify-between pl-1">
                                    <div class="flex min-w-0 items-center gap-3">
                                        <div class="h-10 w-10 shrink-0 rounded-sm" [pClass]="accentClass()">
                                            <img
                                                ngSrc="assets/images/advania-small.png"
                                                priority
                                                alt="Advania logo"
                                                class="h-full w-auto p-1"
                                                height="769"
                                                width="808" />
                                        </div>
                                        <div class="mt-1 flex min-w-0 flex-col leading-tight">
                                            <span
                                                class="m-0 truncate p-0 font-serif font-bold text-neutral-700 dark:text-white">
                                                {{ activeCustomerName() }}
                                            </span>
                                            <span
                                                class="m-0 truncate p-0 text-left text-sm text-neutral-700 dark:text-white">
                                                {{ activeCustomerNumber() }}
                                            </span>
                                        </div>
                                    </div>
                                    <svg
                                        [lucideIcon]="Chevrons"
                                        class="h-6 w-6 shrink-0 text-neutral-700 dark:text-white"></svg>
                                </div>
                            </button>
                        } @else {
                            <button
                                pButton
                                variant="text"
                                severity="secondary"
                                [disabled]="true"
                                class="!w-full !p-0.5 !opacity-100">
                                <div class="flex w-full items-center justify-between pl-1">
                                    <div class="flex min-w-0 items-center gap-3">
                                        <div class="h-10 w-10 shrink-0 rounded-sm" [pClass]="accentClass()">
                                            <img
                                                ngSrc="assets/images/advania-small.png"
                                                priority
                                                alt="Advania logo"
                                                class="h-full w-auto p-1"
                                                height="769"
                                                width="808" />
                                        </div>
                                        <div class="mt-1 flex min-w-0 flex-col text-left leading-tight">
                                            <span
                                                class="m-0 truncate p-0 font-serif font-bold text-neutral-700 dark:text-white">
                                                {{ internalName() }}
                                            </span>
                                            <span
                                                class="m-0 truncate p-0 text-left text-sm text-neutral-700 dark:text-white">
                                                {{ internalDescription() }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </button>
                        }
                    </ng-template>
                    <ng-template advSidebarIcon>
                        <div class="flex flex-col items-center">
                            @if (workspace() === Workspace.Customer) {
                                <button
                                    pButton
                                    variant="text"
                                    severity="secondary"
                                    (click)="cs.toggle($event)"
                                    class="!overflow-x-hidden !p-1.5"
                                    [attr.aria-label]="customerSelectorText()">
                                    <div class="flex w-full items-center">
                                        <div class="h-8 w-8 rounded-sm" [pClass]="accentClass()">
                                            <img
                                                ngSrc="assets/images/advania-small.png"
                                                priority
                                                alt="Advania logo"
                                                class="h-full w-auto p-1"
                                                height="769"
                                                width="808" />
                                        </div>
                                    </div>
                                </button>
                            } @else {
                                <button
                                    pButton
                                    variant="text"
                                    severity="secondary"
                                    [disabled]="true"
                                    class="!overflow-x-hidden !p-1.5 !opacity-100">
                                    <div class="flex w-full items-center">
                                        <div class="h-8 w-8 rounded-sm" [pClass]="accentClass()">
                                            <img
                                                ngSrc="assets/images/advania-small.png"
                                                priority
                                                alt="Advania logo"
                                                class="h-full w-auto p-1"
                                                height="769"
                                                width="808" />
                                        </div>
                                    </div>
                                </button>
                            }
                        </div>
                    </ng-template>
                </adv-sidebar-header>

                <adv-sidebar-body>
                    @for (
                        section of workspace() === Workspace.Internal ? internalSidebarSections() : sidebarSections();
                        track section.label
                    ) {
                        <adv-sidebar-body-header>{{ section.label }}</adv-sidebar-body-header>
                        @for (item of section.items; track item.id) {
                            <adv-sidebar-body-item
                                [route]="item.route"
                                [label]="item.label"
                                [tooltip]="item.tooltip"
                                [shortcut]="showShortcuts ? item.shortcut : undefined"
                                [disabled]="item.disabled ?? false"
                                [testId]="item.id">
                                <span>
                                    <svg
                                        [lucideIcon]="item.icon"
                                        class="h-5 w-5"
                                        [class.stroke-1]="item.id === 'AdvaniaServices'"></svg>
                                </span>
                            </adv-sidebar-body-item>
                        }
                    }
                </adv-sidebar-body>

                <adv-sidebar-footer>
                    <ng-template advSidebarExpanded>
                        @if (isInternalUser()) {
                            <span id="sidebar-mode-label" class="sr-only">{{ modeLabel() }}</span>
                            <p-select-button
                                data-testid="sidebar-mode-toggle"
                                [options]="modeOptions()"
                                [ngModel]="workspace()"
                                (ngModelChange)="switchWorkspace($event)"
                                [allowEmpty]="false"
                                [fluid]="true"
                                [pTooltip]="workspaceTooltip()"
                                [attr.aria-keyshortcuts]="workspaceAriaShortcut"
                                ariaLabelledBy="sidebar-mode-label"
                                optionLabel="label"
                                optionValue="value"
                                size="small">
                                <ng-template #item let-item>
                                    <div class="flex items-center gap-2">
                                        <svg [lucideIcon]="item.icon" class="h-4 w-4"></svg>
                                        <span class="mt-1">{{ item.label }}</span>
                                    </div>
                                </ng-template>
                            </p-select-button>
                        }
                        <button
                            pButton
                            class="!w-full"
                            variant="text"
                            severity="secondary"
                            (click)="up.toggle($event)"
                            [attr.aria-label]="userProfileText()">
                            @if (!user()?.profilePicture) {
                                <svg [lucideIcon]="UserIcon" class="text-neutral-700 dark:text-white"></svg>
                            } @else {
                                <img
                                    [src]="user()?.profilePicture"
                                    alt="User profile picture"
                                    class="h-6 w-6 rounded-full object-cover" />
                            }
                            <span class="mt-1 mr-auto font-bold text-neutral-700 dark:text-white">
                                {{ user()?.displayName }}
                            </span>
                            <svg [lucideIcon]="Chevrons" class="h-6 w-6 text-neutral-700 dark:text-white"></svg>
                        </button>
                    </ng-template>
                    <ng-template advSidebarIcon>
                        @if (isInternalUser()) {
                            <button
                                pButton
                                data-testid="sidebar-mode-toggle"
                                variant="text"
                                severity="secondary"
                                (click)="
                                    switchWorkspace(
                                        workspace() === Workspace.Internal ? Workspace.Customer : Workspace.Internal
                                    )
                                "
                                [pTooltip]="workspaceTooltip()"
                                [attr.aria-label]="modeToggleLabel()"
                                [attr.aria-keyshortcuts]="workspaceAriaShortcut">
                                <svg [lucideIcon]="modeToggleIcon()" class="h-5 w-5"></svg>
                            </button>
                        }
                        <button
                            pButton
                            class="!w-full"
                            variant="text"
                            severity="secondary"
                            (click)="up.toggle($event)"
                            [attr.aria-label]="userProfileText()">
                            @if (!user()?.profilePicture) {
                                <svg [lucideIcon]="UserIcon" class="text-neutral-700 dark:text-white"></svg>
                            } @else {
                                <img
                                    [src]="user()?.profilePicture"
                                    alt="User profile picture"
                                    class="h-6 w-6 rounded-full object-cover p-0" />
                            }
                        </button>
                    </ng-template>
                </adv-sidebar-footer>
            </adv-sidebar>

            <div class="flex min-w-0 flex-1 flex-col">
                <!-- Top Bar -->
                <div class="bg-background/90 sticky top-0 z-20 p-2 pb-1 backdrop-blur">
                    <div
                        class="mt-1 flex flex-row items-center gap-0 md:gap-0.5"
                        [pClass]="[{ 'mb-2.75': sidebarOpen() }, { 'mb-1.25': !sidebarOpen() }]">
                        <button
                            pButton
                            severity="secondary"
                            (click)="toggleSidebar()"
                            [pTooltip]="toggleSidebarTooltip()"
                            [tooltipPosition]="'bottom'"
                            [attr.aria-label]="toggleSidebarText()">
                            <svg [lucideIcon]="sidebarIcon()" class="h-6 w-6"></svg>
                        </button>
                        <p-divider class="m-0! mr-3! md:mr-3.5!" layout="vertical" />
                        <div class="min-w-0 flex-1 overflow-hidden">
                            <adv-breadcrumb [currentUrl]="currentUrl()" [home]="home()" />
                        </div>
                    </div>
                    <p-splitter class="w-full!" />
                </div>
                <!-- Main Content -->
                <div
                    data-adv-fullscreen-boundary
                    class="min-h-0 min-w-0 flex-1 overflow-x-hidden"
                    [class.overflow-y-auto]="!isItFinancialsV2Route()"
                    [class.overflow-y-hidden]="isItFinancialsV2Route()">
                    <div class="h-full min-h-0 pt-2 pr-2 pl-2">
                        <router-outlet />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <p-popover #up>
        <app-user-profile />
    </p-popover>
    <p-popover #cs>
        <app-customer-selector />
    </p-popover>
}
